import { QueryFunctionContext } from '@tanstack/react-query'
import { GET, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import accountMapEndpoints from '../api/accountMapEndpoints'
import accountMapQueryKeys from '../queries/accountMapQueryKeys'
import { AccountMapRule } from '../types/AccountMapRule'
import { Company } from '../../../types/company/Company'

export const fetchAccountMapRules = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof accountMapQueryKeys)['list']>>) => {
  return backendRequest<AccountMapRule[]>({
    method: GET,
    url: accountMapEndpoints.list(companyId),
    signal
  })
}

export const updateAccountMapRules = async (companyId: Company['id'], rules: AccountMapRule[]) => {
  return backendRequest<AccountMapRule[]>({
    method: PUT,
    url: accountMapEndpoints.list(companyId),
    data: rules
  })
}
